import { EventEmitter } from 'events';
export class Emitter extends EventEmitter {
    emit(type, ...args) {
        const a = super.emit(type, ...args);
        const b = super.emit('*', type, ...args);
        return a && b;
    }
}
//# sourceMappingURL=Emitter.mjs.map